import _, { DebouncedFunc } from 'lodash';
import React, { useEffect, useState } from 'react';

const refetchDebouncer = (refetch: () => Promise<any>) => _.debounce(async () => await refetch(), 500, { trailing: true, leading: false });

interface MarshalledRequest {
	id: number;
	abort: () => void;
	exec: DebouncedFunc<() => Promise<any>>;
}
const sort = ({ id: aId = 0 } = { id: 0 }, { id: bId = 0 } = { id: 0 }) => aId + bId;

export const useDebounceRefetch = <TRefetch extends any, TWatch = unknown>(
	refetch: () => Promise<any>,
	watch: TWatch,
	requestAborter: () => void
) => {
	const [requests, add] = useState<MarshalledRequest[]>([]);
	const [current, setCurrent] = useState<MarshalledRequest | undefined>(undefined);
	const debouncer = React.useCallback(refetchDebouncer(refetch), [refetchDebouncer]);

	const marshaller = () => {
		add(
			[
				{
					id: _.size(requests),
					abort: () => {
						requestAborter(), debouncer.cancel();
					},
					exec: debouncer
				},
				...requests
			].sort(sort)
		);
	};

	useEffect(() => {
		if (current) current.abort();
		setCurrent(requests.pop());
	}, [requests]);

	useEffect(() => {
		if (current) current.exec();
		return () => current?.abort();
	}, [current]);
	const exec = React.useCallback(marshaller, [watch]);

	return { exec, requests };
};
